import { FC, useEffect } from 'react';
import i18n from 'i18n';
import DefaultLayout from 'components/Rsuite/Layout/DefaultLayout';
import { useOrderStore } from 'store/orderStore';
import { useCampaignStore } from 'store/campaignStore';
import { RsBreadCrumb } from 'components/Rsuite/BreadCrumb';
import CreatePage from './Components/ActionType/CreatePage';
import EditPage from './Components/ActionType/EditPage';
import CopyPage from './Components/ActionType/CopyPage';
import { useProductStore } from 'store/productStore';
import useCreativeStore from 'store/creativeStore';
import { useCoreContext } from 'contexts/coreContext';
import _ from 'lodash';
import { AdType } from 'core/rtbCampaign/RtbCampaign';
import Skeleton from 'react-loading-skeleton';
import { ActionType } from 'core/rtbCampaign/singlePage/common';

/**
 * 廣告活動單頁
 * 這個元件主要用來控制腳色權限是否能access到廣告活動的新增或編輯頁面
 * @param {string} actionType - 活動編輯類型
 * @returns {ReactElement}
 */
const RtbCampaignSinglePage: FC<{ actionType: ActionType }> = (props) => {
  const { order } = useOrderStore();
  const { campaign, adType, resetCampaignStore } = useCampaignStore();
  const { resetProductStore } = useProductStore();
  const { resetCreativeStore, setCreativesPermission, handleAddBindCreatives } =
    useCreativeStore();
  const actionType = props.actionType;
  const title = `adType.${adType}`;

  const core = useCoreContext();
  const creativesPermission: { [key: string]: boolean } = _.get(
    core,
    'accountManager.localeMeta.addonFeatures.creatives',

    {},
  );
  const actionMode = () => {
    switch (actionType) {
      case 'create':
        return <CreatePage />;
      case 'edit':
        return <EditPage />;
      case 'copy':
        return <CopyPage />;
      default:
        return '';
    }
  };

  const sectionTitle = () => {
    switch (actionType) {
      case 'create':
        return `新增${i18n.t<string>(title)}`;
      case 'edit':
        return adType === AdType.UNKNOWN ? '' : `編輯${i18n.t<string>(title)}`;
      case 'copy':
        return adType === AdType.UNKNOWN ? '' : `複製${i18n.t<string>(title)}`;
      default:
        return '';
    }
  };

  const breadcrumbTitle = () => {
    switch (actionType) {
      case 'create':
        return `新增${i18n.t<string>(title)}`;
      case 'edit':
        return adType === AdType.UNKNOWN ? '' : `${campaign?.basic?.name}`;
      case 'copy':
        return adType === AdType.UNKNOWN ? '' : `${campaign?.basic?.name}`;
      default:
        return '';
    }
  };
  useEffect(() => {
    useCampaignStore.setState({
      actionType: actionType,
    });
    setCreativesPermission(creativesPermission);
    // 如果不是活動頁面，則清空 campaign
    return () => {
      useCampaignStore.setState({ actionType: ActionType.UNKNOWN });
      resetCampaignStore();
      resetProductStore();
      resetCreativeStore();
      handleAddBindCreatives([]);
      setCreativesPermission({});
    };
  }, []);

  return (
    <DefaultLayout
      title={
        breadcrumbTitle() === '' ? (
          <Skeleton width={150} height={25} />
        ) : (
          sectionTitle()
        )
      }
      breadcrumb={
        breadcrumbTitle() === '' ? (
          <Skeleton width={300} />
        ) : (
          <RsBreadCrumb
            data={[
              {
                label: i18n.t<string>('orderHome.labels.title'),
                href: '/orders',
              },
              {
                label: order?.projectName,
                href: `/orders/${order?.orderNumber}`,
              },
              {
                label: breadcrumbTitle(),
                active: true,
              },
            ]}
          />
        )
      }
    >
      {actionMode()}
    </DefaultLayout>
  );
};

export default RtbCampaignSinglePage;
